export default "__VITE_ASSET__B4Vxp6J$__"